export const namespaced = true

export const state = {
  history: [],
  shortHistory: []
}

export const mutations = {
  ADD(state, data) {
    // handle back btn: - if new input is same as some input in history array then just remove elements
    if (state.history.length > 1) {
      let newName = data.text + data.name
      let oldName
      for (var i = 0; i < state.history.length - 1; i++) {
        oldName = state.history[i].text + state.history[i].name
        if (newName === oldName) {
          state.history = state.history.slice(0, i + 1)
          state.shortHistory = []
          return
        }
      }
      if (state.history.length > 0) {
        state.history[state.history.length - 1].tab = data.text
      }
      state.history.push(data)
    } else {
      if (state.history.length > 0) {
        state.history[state.history.length - 1].tab = data.text
      }
      state.history.push(data)
    }
  },
  UPDATE(state, data) {
    if (data.text === state.history[state.history.length - 1].text) {
      state.history[state.history.length - 1].name = data.name
    }
  },
  REMOVE(state) {
    if (state.history.length > 0) {
      state.history.pop()
    }
  },
  CLEAR(state) {
    state.history = []
  },
  GO_BACK(state, data) {
    let popNum = data + 1
    console.log('go back', data, popNum)
    for (var i = 0; i < popNum; i++) {
      state.history.pop()
    }
  },
  SET_SHORT_NAVIGATION(state) {
    state.shortHistory.push(state.history[state.history.length - 2])
    state.shortHistory.push(state.history[state.history.length - 1])
  },
  REMOOVE_SHORT_NAVIGATION(state) {
    state.shortHistory = []
  }
}

export const actions = {
  add({ commit }, data) {
    commit('ADD', data)
  },
  update({ commit }, data) {
    commit('UPDATE', data)
  },
  remove({ commit }) {
    commit('REMOVE')
  },
  clear({ commit }) {
    commit('CLEAR')
  },
  goBack({ commit }, data) {
    commit('GO_BACK', data)
    commit('REMOOVE_SHORT_NAVIGATION')
  },
  setShortNavigation({ commit }) {
    commit('SET_SHORT_NAVIGATION')
  }
}

export const getters = {
  getHistory: state => {
    if (state.shortHistory.length > 0) {
      return state.shortHistory
    }
    return state.history
  }
}
